import ngRouter from '@uirouter/angularjs'
import notificationService from '../../services/notificationService/notificationService';
import moment from 'moment/moment';
import 'jquery';
import appName from '../../appName';
import Raven from 'raven-js';

// import 'angular-bootstrap-lightbox/dist/angular-bootstrap-lightbox.css'
// import 'angular-bootstrap-lightbox';

export default angular.module('help', [
	ngRouter,
	notificationService
]).config(($stateProvider) => {
	$stateProvider.state({
		name: 'autovraky.help',
		url: 'help',
		templateUrl: 'modules/help/help.tpl.html'
	});
}).controller('HelpController', function(notify, $window, userService, $http, $httpParamSerializerJQLike) {
	this.messages = notify.getMessages();
	let user = userService.getUserSettings();
	let appSettings = userService.getAppSettings();
	
	this.contact = {message: '', name: '', phone: appSettings.user.phone, email: appSettings.user.email};
	
	this.appName = appName;
	
	
	this.helpType = 'web';
	
	this.contactSupport = () => {
		let text = this.contact.message + "\n\n------- ZPRÁVY PROGRAMU --------\n";
		
		this.messages.forEach((msg) => {
			text += '[' + moment(msg.date).format('DD.MM.YYYY HH:mm').toString() + '] [' + msg.type + '] ' + msg.msg + "\n";
		});
		
		let user = userService.getUserSettings().workplace;
		let appSettings = userService.getAppSettings();
		let isohUser = userService.getUser();
		
		text += "\n------ INFORMACE O UŽIVATELI -------\nIČ: " + user.ic +
			"\nLogin: " + isohUser.login +
			"\nJméno: " + this.contact.name +
			"\nProvoz: " + user.provoz +
			"\nIdentifikace: " + user.ident +
			"\nE-mail: " + this.contact.email +
			"\nTelefon: " + this.contact.phone;
		
		this.sendMail('support@mathesio.cz', 'Podpora Freeware Autovraky', text);
	};
	
	this.sendMail = (email, subject, message) => {
		let isohUser = userService.getUser();
		// let url = 'http://localhost/matcomp/project-ma-isoh-web';
		let url = 'https://autovraky.mzp.cz/autovrak';
		
		$http({
			method: 'POST',
			url: url + '/api/send-mail',
			data: $httpParamSerializerJQLike({data: {
					login: isohUser.login,
					password: isohUser.password,
					type: 'FreewareAutovrakyContact',
					recipients: [email],
					subject: subject,
					data: {
						message: message
					}
				}
			}),
			paramSerializer: '$httpParamSerializerJQLike',
			headers: {'Content-Type': 'application/x-www-form-urlencoded'}
		}).success(() => {
			notify.success('Zpráva odeslána, budeme Vás kontaktovat');
			this.contact = {message: '', name: '', phone: appSettings.user.phone, email: appSettings.user.email};
		}).error((error) => {
			notify.error('Omlouváme se, nepodařilo se odeslat zprávu technické podpoře - ' + error);
			
			Raven.captureMessage('Nepodarilo se poslat e-mail na tech support', {
				level: 'error',
				extra: {error: error}
			});
		});
	};
	
	// this.openLightbox = (image) => {
	// 	Lightbox.openModal([image], 0);
	// }
}).name;



// WEBPACK FOOTER //
// build/modules/help/help.js